import React, { Component } from "react";

import { Snackbar, Drawer } from "@material-ui/core";
import { Alert } from "@material-ui/lab";

import CookieHandler from "../../common/CookieHandler";
import config from "../../../config/config";
import api from "../../../api/api";

// import mother vessel Coasl Procurement Charges
import MVExportTaxAdd from "./Export-Tax-Add";
import MVExportTaxView from "./Export-Tax-View";
import MVExportTaxUpdate from "./Export-Tax-Update";
import { localDateFormate, toLocaleString } from "../../common/common";
import Loader from "../../common/Loader";

export default class MvExportTaxList extends Component {
  constructor(props) {
    super(props);
    this.Cookie = new CookieHandler();
    this.state = {
      MvExportTaxs: [],
      isLoading: true,
      features: [],
      updateDocuments: false,
    };
  }

  async componentDidMount() {
    if (!this.Cookie.isLoggedIn()) {
      this.props.history.replace("/logout");
    } else {
      var features = this.Cookie.getCookie("features");
      this.setState({ features: features });
      if (!(features.includes("267") || features.includes("97"))) {
        window.location.href = "/dashboard";
      }
      var loginUserID = this.Cookie.getCookie("loginUserId");
      var idToken = this.Cookie.getIdTokenCookie();
      try {
        var businessNoID = this.props.businessNoID;
        //Get businessNumber API based on businessNumber
        await api
          .getBusinessNumber(businessNoID, loginUserID, idToken)
          .then((response) => {
            if (response.status >= 200 && response.status < 300) {
              response.json().then((res) => {
                if (res.code === "200") {
                  if (res.business_number) {
                    var total_delivered_quantity = 0;
                    for (var i of res.business_number
                      .business_number_allocation) {
                      total_delivered_quantity += Number(
                        i.bna_quantity_delivered
                      );
                    }
                    this.setState({
                      businessNo: res.business_number.business_no
                        ? res.business_number.business_no
                        : "",
                      mother_vessel_name: res.business_number.mother_vessel_name
                        ? res.business_number.mother_vessel_name
                        : "",
                      quantity_in_mt: total_delivered_quantity,
                      sac_quantity_in_mt: total_delivered_quantity,
                      dc_quantity_in_mt: total_delivered_quantity,
                      dc_quantity_for_export_tax: total_delivered_quantity,
                      //isLoading: false
                    });
                  }
                } else if (res.code === "601") {
                  this.setState({
                    errorMsg: res.message,
                    snackBarErrorOpen: true,
                  });
                } else if (res.code === "607") {
                  window.location.href = "/logout";
                }
              });
            }
          });
        await api
          .get_mv_pur_fin_export_tax(loginUserID, idToken, businessNoID)
          .then((response) => {
            if (response.status >= 200 && response.status < 300) {
              response.json().then((res) => {
                if (res.code === "200") {
                  if (res.mv_pur_fin_export_tax) {
                    this.setState({
                      MvExportTaxs: res.mv_pur_fin_export_tax,
                      isLoading: false,
                    });
                  } else {
                    alert(
                      "Unexpected error occured. Please contact administrator."
                    );
                  }
                } else if (res.code === "601") {
                  this.setState({
                    errorMsg: res.message,
                    snackBarErrorOpen: true,
                  });
                } else if (res.code === "607") {
                  window.location.href = "/logout";
                }
              });
            }
          });
      } catch (e) {
        window.location.href = "/business-number-list";
      }
    }
  }

  onAddResponse = (value) => {
    if (value.code === "200") {
      this.setState(
        {
          MVExportTaxAdd: false,
          MVExportTaxView: false,
          MVExportTaxUpdate: false,
          openDrawer: false,
          updateDocuments: false,
        },
        () => this.componentDidMount()
      );
    } else {
      this.setState({
        MVExportTaxAdd: false,
        MVExportTaxView:
          value.screen === "MvExportTax" &&
            value.message === "alreadyDataAvailable"
            ? true
            : false,
        MVExportTaxUpdate: false,
        openDrawer: true,
        updateDocuments: false,
      });
    }
  };

  CallbackDrawerClose = (childData) => {
    this.setState(
      {
        openDrawer: childData,
        MVExportTaxAdd: false,
        MVExportTaxView: false,
        MVExportTaxUpdate: false,
        updateDocuments: false,
      },
      () => this.componentDidMount()
    );
  };

  onUpdateResponse = (value) => {
    if (value) {
      this.setState(
        {
          MVExportTaxAdd: false,
          MVExportTaxView:
            value.code === "200" && value.screen === "MvExportTax"
              ? true
              : false,
          MVExportTaxUpdate: false,
          updateDocuments: false,
        },
        () => this.componentDidMount()
      );
    }
  };

  CallbackViewPage = (childData) => {
    this.setState(
      {
        openDrawer: true,
        MVExportTaxUpdate: false,
        MVExportTaxAdd: false,
        MVExportTaxView: childData === "MvExportTax" ? true : false,
        updateDocuments: false,
      },
      () => this.componentDidMount()
    );
  };

  editCallback = (childData) => {
    this.setState(
      {
        openDrawer: true,
        MVExportTaxUpdate: childData === "MvExportTax" ? true : false,
        MVExportTaxAdd: false,
        MVExportTaxView: false,
        updateDocuments: false,
      },
      () => this.componentDidMount()
    );
  };

  deleteCharges = (data) => {
    var loginUserID = this.Cookie.getCookie("loginUserId");
    var idToken = this.Cookie.getIdTokenCookie();
    var finalData = data;
    finalData.mv_export_tax_id = data.id;
    finalData.login_user_id = loginUserID;
    finalData.idtoken = idToken;
    finalData.status = "Deleted";
    //Delete Stevedore costing charge
    api.update_mv_export_tax(finalData).then((response) => {
      if (response.status >= 200 && response.status < 300) {
        response.json().then((res) => {
          if (res.code === "200") {
            this.setState(
              {
                snackBarSuccessOpen: true,
                successMsg: res.message,
              },
              () => this.componentDidMount()
            );
          } else if (res.code === "601") {
            this.setState({ errorMsg: res.message, snackBarErrorOpen: true });
          } else if (res.code === "607") {
            window.location.href = "/logout";
          } else if (res.code === "624") {
            this.setState({
              errorMsg: res.columns.length > 0 ? res.columns[0] : "",
              snackBarErrorOpen: true,
            });
          }
        });
      }
    });
  };

  render() {
    let drawerComponent;
    if (this.state.MVExportTaxAdd) {
      drawerComponent = (
        <MVExportTaxAdd
          businessNoID={this.props.businessNoID}
          onAddResponse={this.onAddResponse}
          returnCallbackDrawerClose={this.CallbackDrawerClose}
        />
      );
    } else if (this.state.MVExportTaxView && this.state.businessNo) {
      drawerComponent = (
        <MVExportTaxView
          ExportTaxID={this.state.ExportTaxID}
          businessNoID={this.state.businessNo}
          returnCallbackDrawerClose={this.CallbackDrawerClose}
          returnEditCallback={this.editCallback}
          returnDocumentsHandler={() => {
            this.setState({
              showDrawer: true,
              MVExportTaxUpdate: true,
              MVExportTaxView: false,
              MVExportTaxAdd: false,
              updateDocuments: true,
            });
          }}
        />
      );
    } else if (this.state.MVExportTaxUpdate && this.state.businessNo) {
      drawerComponent = (
        <MVExportTaxUpdate
          ExportTaxID={this.state.ExportTaxID}
          businessNoID={this.state.businessNo}
          onUpdateCosting={this.onUpdateResponse}
          returnCallbackViewPage={this.CallbackViewPage}
          updateDocuments={this.state.updateDocuments}
        />
      );
    }
    if (this.state.isLoading) {
      return <Loader />;
    } else {
      return (
        <div>
          <div className="row clearfix content-header border-bottom">
            <div className="row clearfix content-header border-bottom">
              <h4 className="mt-2" style={{ padding: "4px" }}>
                Export Tax - {this.state.mother_vessel_name} {"(" + this.state.businessNo + ")"}
              </h4>
              {(this.state.features.includes("266") ||
                this.state.features.includes("97")) && (
                  <i
                    className="fa fa-plus-circle ml-2 mt-3"
                    aria-hidden="true"
                    style={{
                      fontSize: 22,
                      color: config.themeColor,
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      this.setState({
                        openDrawer: true,
                        MVExportTaxAdd: true,
                        MVExportTaxView: false,
                        MVExportTaxUpdate: false,
                      });
                    }}
                  />
                )}
            </div>
          </div>
          <Snackbar
            anchorOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
            open={this.state.snackBarErrorOpen}
            onClose={() => this.setState({ snackBarErrorOpen: false })}
            style={{ width: "450px" }}
          >
            <Alert
              elevation={6}
              variant="filled"
              onClose={() => this.setState({ snackBarErrorOpen: false })}
              severity="error"
              style={{ width: "100%" }}
            >
              {this.state.errorMsg}
            </Alert>
          </Snackbar>
          <Snackbar
            anchorOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
            style={{ width: "450px" }}
            open={this.state.snackBarSuccessOpen}
            autoHideDuration={100000}
            onClose={() => this.setState({ snackBarSuccessOpen: false })}
          >
            <Alert
              elevation={6}
              variant="filled"
              onClose={() => this.setState({ snackBarSuccessOpen: false })}
              severity="success"
              style={{ width: "100%" }}
            >
              {this.state.successMsg}
            </Alert>
          </Snackbar>
          <Drawer
            anchor="right"
            open={this.state.openDrawer}
            variant="temporary"
            elevation={20}
            style={{ overflow: "initial" }}
          >
            <div className="row" style={{ width: 800 }}>
              {drawerComponent}
            </div>
          </Drawer>
          <div className="card pl-0 pr-0">
            <div
              className="card-body p-0"
              style={{ backgroundColor: "rgba(25,118,210,.01)" }}
              id="accordion"
            >
              <div className="col-lg-12 mb-2 p-0">
                <div className="row">
                  <div className="table-responsive">
                    <table className="table">
                      <thead style={{ backgroundColor: "rgb(249, 249, 249)" }}>
                        <tr>
                          <th
                            nowrap="true"
                            className="allocation_table_header_label border-0"
                          >
                            Costing ID
                          </th>
                          <th
                            nowrap="true"
                            className="allocation_table_header_label border-0"
                          >
                            PEB No
                          </th>
                          <th
                            nowrap="true"
                            className="allocation_table_header_label border-0 text-right"
                          >
                            PEB Date
                          </th>
                          <th
                            nowrap="true"
                            className="allocation_table_header_label border-0"
                          >
                            ID Billing
                          </th>
                          <th
                            nowrap="true"
                            className="allocation_table_header_label border-0 text-right"
                          >
                            Quantity For Export Tax
                          </th>
                          <th
                            nowrap="true"
                            className="allocation_table_header_label border-0 text-right"
                          >
                            Export Tax Per MT
                          </th>
                          <th
                            nowrap="true"
                            className="allocation_table_header_label border-0 text-right"
                          >
                            Export Tax
                          </th>
                          <th
                            nowrap="true"
                            className="allocation_table_header_label border-0"
                          >
                            Reported to BI
                          </th>
                          <th
                            nowrap="true"
                            className="allocation_table_header_label border-0 text-left pl-4"
                          >
                            Action
                          </th>
                        </tr>
                      </thead>
                      {this.state.MvExportTaxs.length > 0 ? (
                        <tbody>
                          {this.state.MvExportTaxs.map((idr, indx) => (
                            <tr key={indx}>
                              <td className="allocation_table_value">
                                {(this.state.features.includes("267") ||
                                  this.state.features.includes("97")) && (
                                    <i
                                      aria-hidden="true"
                                      style={{
                                        fontStyle: "normal",
                                        color: config.themeColor,
                                        cursor: "pointer",
                                        whiteSpace: "nowrap",
                                      }}
                                      onClick={() =>
                                        this.setState({
                                          openDrawer: true,
                                          MVExportTaxAdd: false,
                                          MVExportTaxView: true,
                                          MVExportTaxUpdate: false,
                                          businessNo: idr.business_no_id,
                                          ExportTaxID: idr.id,
                                        })
                                      }
                                    >
                                      {idr.costing_no}
                                    </i>
                                  )}
                              </td>
                              <td
                                className="allocation_table_value"
                                nowrap="true"
                              >
                                {idr.peb_no}
                              </td>
                              <td
                                className="allocation_table_value text-right"
                                nowrap="true"
                              >
                                {localDateFormate(idr.peb_date)}
                              </td>
                              <td
                                className="allocation_table_value"
                                nowrap="true"
                              >
                                {idr.id_biling}
                              </td>
                              <td
                                className="allocation_table_value text-right"
                                nowrap="true"
                              >
                                {idr.quantity_for_export_tax
                                  ? toLocaleString(idr.quantity_for_export_tax)
                                  : 0}
                              </td>
                              <td
                                className="allocation_table_value text-right"
                                nowrap="true"
                              >
                                {idr.export_tax_per_mt
                                  ? toLocaleString(idr.export_tax_per_mt)
                                  : 0}{" "}
                                {config.company === "SRPL" || config.company === "AVS" ||
                                  config.company === "PRPL"
                                  ? "USD"
                                  : "IDR"}
                              </td>
                              <td
                                className="allocation_table_value text-right"
                                nowrap="true"
                              >
                                {idr.export_tax
                                  ? toLocaleString(idr.export_tax)
                                  : 0}
                              </td>
                              <td
                                className="allocation_table_value"
                                nowrap="true"
                              >
                                {idr.reported_to_bi}
                              </td>
                              <td
                                nowrap="true"
                                className="table_td text-left pl-4"
                              >
                                {(this.state.features.includes("268") ||
                                  this.state.features.includes("97")) && (
                                    <i
                                      className="fa fa-pencil"
                                      style={{
                                        fontSize: 14,
                                        color: config.themeColor,
                                        cursor: "pointer",
                                      }}
                                      data-toggle="modal"
                                      title="Edit floating crane charges"
                                      data-placement="bottom"
                                      onClick={() =>
                                        this.setState({
                                          businessNo: idr.business_no_id,
                                          ExportTaxID: idr.id,
                                          openDrawer: true,
                                          MVExportTaxUpdate: true,
                                        })
                                      }
                                    ></i>
                                  )}
                                {idr.payment_postings_availability === 0 &&
                                  (this.state.features.includes("269") ||
                                    this.state.features.includes("97")) &&
                                  idr.approval_status === "Pending" && (
                                    <i
                                      className="fa fa-trash-o"
                                      style={{
                                        paddingLeft: 10,
                                        fontSize: 14,
                                        color: config.themeColor,
                                        cursor: "pointer",
                                      }}
                                      onClick={() => this.deleteCharges(idr)}
                                    ></i>
                                  )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      ) : (
                        <tbody>
                          <tr>
                            <td colSpan="5" className="p-2">
                              No data available
                            </td>
                          </tr>{" "}
                        </tbody>
                      )}
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
}
